import axios from "fetch-api/fetch-api";
import { IVehicle } from "interfaces/session/IVehicle";
import { IUpdateSelectedVehicle } from "../interfaces/garage-apis";
import { ZendeskVehicleSync } from "../../util/vehicle/ZendeskVehicleSync";

export function updateSelectedVehicle(vehicle: IVehicle) {
  let make;
  let model;
  let year;

  ZendeskVehicleSync({ make, model, year });

  return axios.post<IUpdateSelectedVehicle>("/update-selected-vehicle-v4", { ...vehicle });
}
